// src/components/attributes/attributes-empty.tsx

/**
 * Attributes Empty State Component
 * Shown when no attributes exist for a category
 */

import { Tags, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { AttributeCategory } from '@/types/attribute'
import { CATEGORY_LABELS } from '@/types/attribute'

interface AttributesEmptyProps {
  category: AttributeCategory
  onCreateClick: () => void
}

export function AttributesEmpty({ category, onCreateClick }: AttributesEmptyProps) {
  const categoryLabel = CATEGORY_LABELS[category].toLowerCase()

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="rounded-full bg-muted p-3 mb-4">
        <Tags className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium mb-1">
        No {categoryLabel} attributes defined yet
      </h3>
      <p className="text-sm text-muted-foreground mb-4 max-w-sm">
        Create {categoryLabel} attributes to use them in your access control policies.
      </p>
      <Button onClick={onCreateClick}>
        <Plus className="mr-2 h-4 w-4" />
        Create your first {categoryLabel} attribute
      </Button>
    </div>
  )
}
